export enum OnboardingDataLayerEventError {
    IneligiblePRM = "ineligiblePRM",
    IneligiblePCE = "ineligiblePCE",
    MeterAdressDifferent = "meterAdressDifferent",
    PaymentDetails = "paymentDetails",
}
